import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-cd-multiple-accordion-panel',
  templateUrl: './cd-multiple-accordion-panel.component.html',
  styleUrls: ['./cd-multiple-accordion-panel.component.scss'],
  imports: [CdsIconModule, NgClass],
})
export class CdMultipleAccordionPanelComponent implements OnInit {
  @Input() upIcon = 'action:button_down_outlined';
  @Input() downIcon = 'action:button_down_filled';
  @Output() triggerToggle = new EventEmitter<boolean>();
  expand = false;

  ngOnInit(): void {}

  trigger() {
    this.expand = !this.expand;
    this.triggerToggle.emit(this.expand);
  }
}
